import { render, staticRenderFns } from "./CockpitOffcanvas.vue?vue&type=template&id=4a353ee8&scoped=true"
import script from "./CockpitOffcanvas.vue?vue&type=script&lang=js"
export * from "./CockpitOffcanvas.vue?vue&type=script&lang=js"
import style0 from "./CockpitOffcanvas.vue?vue&type=style&index=0&id=4a353ee8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a353ee8",
  null
  
)

export default component.exports